export default __webpack_public_path__ + "static/media/form_2.c0ead8ff.jpg";